<header class="header-sticky">
    <mat-toolbar class="header-box d-flex justify-content-between">
        <app-logo-header></app-logo-header>

        <section class="header-tabs desktop-nav">
            <ul>
                <li [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
                    <a class="header-link" routerLink="/" (click)="getJoinNow()">{{'home' | translate}}</a>
                </li>
                <li [routerLinkActive]="['link-active']">
                    <a class="header-link" (click)="openJoinModal()">{{'joinNow' | translate}}</a>
                </li>
                <li [routerLinkActive]="['link-active']">
                    <a class="header-link" routerLink="/about">{{'aboutUs' | translate}}</a>
                </li>
                <li [routerLinkActive]="['link-active']">
                    <a class="header-link" routerLink="/privacy-policy">{{'privacyPolicy' | translate}}</a>
                </li>
                <li [routerLinkActive]="['link-active']">
                    <a class="header-link" routerLink="/faqs">{{'faqs' | translate}}</a>
                </li>
                <li [routerLinkActive]="['link-active']">
                    <a class="header-link" routerLink="/contact-us">{{'contactUs' | translate}}</a>
                </li>
            </ul>
        </section>
        <section class="sign-btn">
            <button class="activeBtn" (click)="openDialog()">{{'signIn' | translate}}</button>
        </section>
    </mat-toolbar>

    <mat-toolbar class="responsive-header mobile-device-nav">
        <app-logo-header></app-logo-header>
        <div class="d-flex gap-2 align-item-center event-mob-hed">
            <section>
                <mat-icon matRipple (click)="toggleMenu()" class="cursor-pointer">menu</mat-icon>
                @if(isMenuOpen){
                <div class="navbar-collapse mobile-menu">
                    <ul>
                        <li [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
                            <a class="header-link" routerLink="/" (click)="getJoinNow()">{{'home' | translate}}</a>
                        </li>
                        <li [routerLinkActive]="['link-active']">
                            <a class="header-link" (click)="openJoinModal()">{{'joinNow' | translate}}</a>
                        </li>
                        <li [routerLinkActive]="['link-active']">
                            <a class="header-link" routerLink="/about">{{'aboutUs' | translate}}</a>
                        </li>
                        <li [routerLinkActive]="['link-active']">
                            <a class="header-link" routerLink="/privacy-policy">{{'privacyPolicy' | translate}}</a>
                        </li>
                        <li [routerLinkActive]="['link-active']">
                            <a class="header-link" routerLink="/faqs">{{'faqs' | translate}}</a>
                        </li>
                        <li [routerLinkActive]="['link-active']">
                            <a class="header-link" routerLink="/contact-us">{{'contactUs' | translate}}</a>
                        </li>
                        <li>
                            <section class="sign-btn">
                                <button class="activeBtn w-100" (click)="openDialog()">{{'signIn' | translate}}</button>
                            </section>
                        </li>
                    </ul>
                </div>
                }
            </section>
            <div>
                 <mat-icon matRipple (click)="openDialog()" class="cursor-pointer">login</mat-icon>
            </div>
        </div>
    </mat-toolbar>
    <mat-divider class="header-divider"></mat-divider>
</header>